import { FunctionComponent } from "react";

import useTypedContext from "hooks/useTypedContext";
import Box from "ds/components/Box";
import IconEmphasized from "ds/components/IconEmphasized";
import TileTitle from "ds/components/Tile/Title";
import TileDescription from "ds/components/Tile/Description";
import BadgeNext from "ds/components/BadgeNext";
import TileWrapperButton from "ds/components/Tile/Wrapper/Button";

import { StackFormContext } from "../context";
import { StackCreationWizardStep } from "../types";

type NewStackIntermediateConfirmationStepTileProps = {
  hasCopiedConfiguration: boolean;
  icon: FunctionComponent;
  title: string;
  description: string;
  action: {
    step: StackCreationWizardStep;
    title: string;
  };
};

const NewStackIntermediateConfirmationStepTile = ({
  hasCopiedConfiguration,
  icon: Icon,
  title,
  description,
  action,
}: NewStackIntermediateConfirmationStepTileProps) => {
  const { setCurrentStep, setIsIntermediateStepActive } = useTypedContext(StackFormContext);
  const actionHandler = () => {
    setIsIntermediateStepActive(false);
    setCurrentStep(action.step);
  };

  const isDefined =
    hasCopiedConfiguration &&
    (action.step === StackCreationWizardStep.Behaviour ||
      action.step === StackCreationWizardStep.Hooks);

  return (
    <TileWrapperButton onClick={actionHandler}>
      <Box align="start" justify="between" fullWidth>
        <Box align="center" grow="1" gap="medium">
          <IconEmphasized icon={Icon} />

          <Box direction="column" gap="small">
            <TileTitle>{title}</TileTitle>
            <TileDescription>{description}</TileDescription>
          </Box>
        </Box>
        {isDefined && <BadgeNext variant="green" type="strong" text="DEFINED" />}
      </Box>
    </TileWrapperButton>
  );
};

export default NewStackIntermediateConfirmationStepTile;
